import type { FlowRunStatus } from '@reflex/flows';

// Exhaustively keyed so adding a run status fails compilation here rather
// than rendering an unstyled fallback.
export const FLOW_STATUS_LABEL: Record<FlowRunStatus, { text: string; className: string }> = {
  running: { text: 'Running', className: 'text-status-info/80' },
  waiting_approval: { text: 'Awaiting approval', className: 'text-status-warning' },
  pending_consent: { text: 'Awaiting consent', className: 'text-status-warning' },
  completed: { text: 'Completed', className: 'text-status-success/80' },
  error: { text: 'Error', className: 'text-status-error/80' },
  cancelled: { text: 'Cancelled', className: 'text-muted-foreground' },
  denied: { text: 'Denied', className: 'text-status-error/80' },
};

export const FLOW_STATUS_DOT: Record<FlowRunStatus, string> = {
  running: 'bg-status-info animate-pulse',
  waiting_approval: 'bg-status-warning animate-pulse',
  pending_consent: 'bg-status-warning animate-pulse',
  completed: 'bg-status-success',
  error: 'bg-status-error',
  cancelled: 'bg-status-neutral',
  denied: 'bg-status-error',
};
